export const colors = {
  white: '#fff',
  red: '#f00',
  lighter: '#f5f5f5',
  light: '#DDD',
  regular: '#999',
  dark: '#A8A8A8',
  darker: '#333',
  black: '#000',
  green: '#32CD32',
  secondary: '#EAB589',
  primary: '#2aabe2',
};

const appColors = colors;

export default colors;
export { appColors };